import { Link } from "gatsby";
import * as React from "react";

interface PricingLinkProps {
  to: string;
  children: string | JSX.Element;
  [key: string]: any;
}

export const PricingLink = ({ to, children, ...props }: PricingLinkProps) =>
  typeof window !== "undefined" ? (
    <Link to={to} state={{ prevPath: location.pathname }} {...props}>
      {children}
    </Link>
  ) : null;
